import Footer from "./footer";
import Navbar from "./navbar";
import { Logo } from "../../assets/images";
import PropTypes from "prop-types";
import Loader from "./loader";

const Templates = (props) => {
  const { children, loading } = props;
  return (
    <div className="h-screen max-w-full relative container scroll-smooth">
      {loading ? (
        <Loader />
      ) : (
        <>
          <Navbar
            logo={Logo}
            basic={{
              classes: `border-gray-200 px-4 transition-all delay-75
              xl:pb-2.5 pt-2.5 bg-gray2/50
              fixed top-0 container text-white text-start z-50`,
            }}
            onScroll={{
              classes: `border-gray-200 transition-all delay-75 px-4 
            md:pb-2.5 md:bg-blueWebsite pt-2.5 bg-gray2
            fixed top-0 w-full text-blueWebsite z-50`,
            }}
          />
          <main className="w-full bg-gray-100">{children}</main>
          <Footer/>
        </>
      )}
    </div>
  );
};

Templates.propTypes = {
  children: PropTypes.elementType,
  loading: PropTypes.bool,
};

export default Templates;
